import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {NavItem} from '../../styles'
import {ActualItem} from '../navigation-item/styles'

export const LoginButtonNavItem = styled(NavItem)``

export const LoginButtonActualItem = styled(ActualItem)`
  padding: 0 8px 0 16px;
`

type LoginButtonHamburgerWrapperProps = {
  navWidth?: number
}

export const LoginButtonHamburgerWrapper = styled.div<LoginButtonHamburgerWrapperProps>`
  position: fixed;
  bottom: 0;
  width: ${({navWidth}): FlattenSimpleInterpolation =>
    css`
      ${navWidth}px
    `};
`
